import { DAMAGE_LEVELS, isSevereOrDeathDamage, requiresSubDamageLevel } from 'utils/damage'
import * as Yup from 'yup'

export const notifyUpdateSchema = (isRequired: boolean) =>
    Yup.object().shape({
        involves_patient: Yup.boolean(),
        u_reclassified_incident_type: Yup.string().required(),
        u_probability_occurence: Yup.string().when(
            ['u_reclassified_incident_type'],
            {
                is: () => isRequired,
                then: (schema) =>
                    schema.required('Preenchimento é obrigatório'),
                otherwise: (schema) => schema.optional()
            }
        ),
        u_oms_classification: Yup.string().required(),
        u_image_risk: Yup.string().required(),
        damage_level: Yup.string().required(),
        incident_title: Yup.string().required(),
        incident_description: Yup.string().required(),
        date_incident: Yup.date().required(),
        location_incident: Yup.string().required(),
        shift_incident: Yup.string().required(),
        incident_sector: Yup.string().required(),
        reporter_sector: Yup.string().required(),
        u_attachments_string: Yup.string(),
        u_attachments_size: Yup.string(),
        u_attachments_url: Yup.string(),
        immediate_corrective_action: Yup.string().required(),
        contributing_mitigating_factors: Yup.string(),
        mitigating_factors: Yup.string(),
        u_categorized_contributing_factor: Yup.string(),
        u_observation_incident_classification: Yup.string().when(
            ['damage_level', 'u_image_risk'],
            {
                is: (damageLevel, imageRisk) =>
                    isSevereOrDeathDamage(damageLevel) || imageRisk === 'u_image_risk_yes',
                then: (schema) => schema.required('Descrição é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_incident_classification: Yup.string().when(
            ['damage_level', 'u_image_risk'],
            {
                is: (damageLevel, imageRisk) =>
                    isSevereOrDeathDamage(damageLevel)|| imageRisk === 'u_image_risk_yes',
                then: (schema) => schema.required('Descrição é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_initials: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_date_of_birth: Yup.date().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_type: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_number: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_gender: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Gênero é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_number_patients_involved: Yup.string().when('involves_patient', {
            is: true,
            then: (schema) =>
                schema.required('Pacientes relacionados é obrigatório'),
            otherwise: (schema) => schema.notRequired()
        }),
        u_notification_multiplier: Yup.string().notRequired(),
        u_never_events_or_sentinel_event: Yup.string().required('Evento possui Never Events ou Evento Sentinela é obrigatório'),
        u_never_events_reference: Yup.string().when(
            'u_never_events_or_sentinel_event',
            {
                is: 'yes',
                then: (schema) => schema.required('Never events é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_sentinel_event_jci: Yup.string().notRequired(),
        u_sub_damage_level: Yup.string().when(
            ['damage_level', 'u_version'],{
                is: (damageLevel, uVersion) => {
                    const normalizedVersion = uVersion?.replace('v', '');
                    const majorVersion = Number(normalizedVersion);
                
                return requiresSubDamageLevel(damageLevel) && 
                    Number.isFinite(majorVersion) && 
                    majorVersion >= 4    
                },
                then: (schema) => schema.required(),
                otherwise: (schema) => schema.nullable().notRequired(),
        })
    })

export const notifyUpdateQASchema = (isRequired: boolean, userProfile?: string) =>
    Yup.object().shape({
        involves_patient: Yup.boolean(),
        u_reclassified_incident_type: Yup.string().required(),
        u_probability_occurence: Yup.string().when(
            ['u_reclassified_incident_type'],
            {
                is: () => isRequired,
                then: (schema) =>
                    schema.required('Preenchimento é obrigatório'),
                otherwise: (schema) => schema.optional()
            }
        ),
        u_oms_classification: Yup.string().required(),
        u_image_risk: Yup.string().required(),
        damage_level: Yup.string().required(),
        incident_title: Yup.string().required(),
        incident_description: Yup.string().required(),
        date_incident: Yup.date().required(),
        location_incident: Yup.string().required(),
        shift_incident: Yup.string().required(),
        incident_sector: Yup.string().required(),
        reporter_sector: Yup.string().required(),
        u_attachments_string: Yup.string(),
        u_attachments_size: Yup.string(),
        u_attachments_url: Yup.string(),
        immediate_corrective_action: Yup.string().required(),
        contributing_mitigating_factors: Yup.string(),
        mitigating_factors: Yup.string(),
        u_categorized_contributing_factor: Yup.string(),
        u_observation_incident_classification: Yup.string().when([], {
            is: () => userProfile !== 'location_qa', // obrigatório apenas se NÃO for QA Unidade
            then: (schema) => schema.required('Descrição é obrigatória'),
            otherwise: (schema) => schema.notRequired(),
        }),
        
        u_incident_classification: Yup.string().when([], {
            is: () => userProfile !== 'location_qa',
            then: (schema) => schema.required('Descrição é obrigatória'),
            otherwise: (schema) => schema.notRequired(),
        }),
        patient_initials: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_date_of_birth: Yup.date().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Data é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_type: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Documento é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_gender: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Gênero é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_number: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Gênero é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_number_patients_involved: Yup.string().when('involves_patient', {
            is: true,
            then: (schema) =>
                schema.required('Pacientes relacionados é obrigatório'),
            otherwise: (schema) => schema.notRequired()
        }),
        u_notification_multiplier: Yup.string().notRequired(),
        u_never_events_or_sentinel_event: isRequired
            ? Yup.string().required('Evento possui Never Events ou Evento Sentinela é obrigatório')
            : Yup.string().notRequired(),
        u_never_events_reference: Yup.string().when(
            'u_never_events_or_sentinel_event',
            {
                is: 'yes',
                then: (schema) => schema.required('Never events é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_sentinel_event_jci: Yup.string().notRequired(),
        u_sub_damage_level: Yup.string().when(
            ['damage_level', 'u_version'],{
                is: (damageLevel, uVersion) => {
                    const normalizedVersion = uVersion?.replace('v', '');
                    const majorVersion = Number(normalizedVersion);
                
                return requiresSubDamageLevel(damageLevel) && 
                        Number.isFinite(majorVersion) && 
                        majorVersion >= 4    
                },
                then: (schema) => schema.required(),
                otherwise: (schema) => schema.nullable().notRequired(),
        })
    })

export const notifyUpdateSchemaForOlderNotifications = (isRequired: boolean) =>
    Yup.object().shape({
        involves_patient: Yup.boolean(),
        u_reclassified_incident_type: Yup.string().required(),
        u_probability_occurence: Yup.string().when(
            ['u_reclassified_incident_type'],
            {
                is: () => isRequired,
                then: (schema) =>
                    schema.required('Preenchimento é obrigatório'),
                otherwise: (schema) => schema.optional()
            }
        ),
        u_oms_classification: Yup.string().required(),
        u_image_risk: Yup.string().required(),
        damage_level: Yup.string().required(),
        incident_title: Yup.string().required(),
        incident_description: Yup.string().required(),
        date_incident: Yup.date().required(),
        location_incident: Yup.string().required(),
        shift_incident: Yup.string().required(),
        incident_sector: Yup.string().required(),
        reporter_sector: Yup.string().required(),
        u_attachments_string: Yup.string(),
        u_attachments_size: Yup.string(),
        u_attachments_url: Yup.string(),
        immediate_corrective_action: Yup.string().required(),
        contributing_mitigating_factors: Yup.string(),
        mitigating_factors: Yup.string(),
        u_categorized_contributing_factor: Yup.string(),
        u_observation_incident_classification: Yup.string().when(
            ['damage_level', 'u_image_risk'],
            {
                is: (damageLevel, imageRisk) =>
                    damageLevel === DAMAGE_LEVELS[0].id ||
                    damageLevel === DAMAGE_LEVELS[1].id ||
                    imageRisk === 'u_image_risk_yes',
                then: (schema) => schema.required('Descrição é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_incident_classification: Yup.string().when(
            ['damage_level', 'u_image_risk'],
            {
                is: (damageLevel, imageRisk) =>
                    damageLevel === DAMAGE_LEVELS[0].id ||
                    damageLevel === DAMAGE_LEVELS[1].id ||
                    imageRisk === 'u_image_risk_yes',
                then: (schema) => schema.required('Descrição é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_initials: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_date_of_birth: Yup.date().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_type: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        document_number: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) =>
                    schema.required('Nome completo é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        patient_gender: Yup.string().when(
            ['involves_patient', 'u_number_patients_involved'],
            {
                is: (involvedPatient, numberPatients) =>
                    involvedPatient === true &&
                    numberPatients === 'um_paciente',
                then: (schema) => schema.required('Gênero é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_number_patients_involved: Yup.string().when('involves_patient', {
            is: true,
            then: (schema) =>
                schema.required('Pacientes relacionados é obrigatório'),
            otherwise: (schema) => schema.notRequired()
        }),
        u_notification_multiplier: Yup.string().notRequired(),
        u_never_events_or_sentinel_event: Yup.string().notRequired(),
        u_never_events_reference: Yup.string().when(
            'u_never_events_or_sentinel_event',
            {
                is: 'yes',
                then: (schema) => schema.required('Never events é obrigatório'),
                otherwise: (schema) => schema.notRequired()
            }
        ),
        u_sentinel_event_jci: Yup.string().notRequired(),
    })

export type NotifyUpdateEventType = Yup.InferType<
    ReturnType<typeof notifyUpdateSchema>
>
